import { compose, withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import SimpleDropdown from '../Common/SimpleDropdown';
import { GalleryCarousel } from '../Common/Carousel/Gallery';

const withFieldLabel = WrappedComponent => ({ displayName, ...props }) => (
  <div className="configurable-product__form-field">
    <div className="configurable-product__form-field-title">
      <h2 className="ProximaNova-Bold text-primary text-uppercase">{displayName}</h2>
    </div>
    <WrappedComponent {...props}/>
  </div>
);

const ConfigurableTextSelect = ({ handleChange, options = [], value }) => {
  const data = options.map(({ displayName, id, isActive = true }) => ({
    disabled: !isActive,
    label: displayName,
    value: id,
  }));

  return <SimpleDropdown
    boxClass="col-12"
    data={data}
    onChange={handleChange}
    value={value}/>;
};

export const undecoratedConfigurableTextSelect = ConfigurableTextSelect;
export const ConfigurableTextSelectFormField = compose(
  withFieldLabel,
  withHandlers({
    handleChange: ({ code, onTextSelectChange }) => ({ target: { value } = {} }) => {
      onTextSelectChange(code, value);
    },
  }),
)(ConfigurableTextSelect);

ConfigurableTextSelectFormField.propTypes = {
  code: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  onTextSelectChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const ConfigurableImageSelect = ({
  handleClick,
  highlightedClass = 'configurable-image__slide-image--selected',
  options = [],
  value,
}) => {
  const images = options
    .filter(({ isActive = true }) => !!isActive)
    .map(({ displayName, id }) => ({
      id,
      src: displayName,
    }));
  const settings = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  return <GalleryCarousel
    handleClick={handleClick}
    highlightedClass={highlightedClass}
    images={images}
    selectedId={value}
    settings={settings}/>;
};

export const undecoratedConfigurableImageSelect = ConfigurableImageSelect;
export const ConfigurableImageSelectFormField = compose(
  withFieldLabel,
  withHandlers({
    handleClick: ({ code, onImageSelectChange }) => (id) => {
      onImageSelectChange(code, id);
    },
  }),
)(ConfigurableImageSelect);

ConfigurableImageSelectFormField.propTypes = {
  code: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  highlightedClass: PropTypes.string,
  onImageSelectChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const ConfigurableTextField = ({
  handleChange,
  minLength,
  maxLength,
  value = '',
}) => (
  <input
    className="form-control"
    minLength={minLength}
    maxLength={maxLength}
    onChange={handleChange}
    type="text"
    value={value}
  />
);

export const ConfigurableTextFormField = compose(
  withFieldLabel,
  withHandlers({
    handleChange: ({ code, onInputChange }) => ({ target: { value = '' } = {} }) => {
      onInputChange(code, value);
    },
  }),
)(ConfigurableTextField);

ConfigurableTextFormField.propTypes = {
  code: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  minLength: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  onInputChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/ConfigurableProduct/ConfigurableProductFormField.js